import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { ContainerModalSetFilter } from './ModalFilter.style'
import { InputAdornment, TextField } from '@mui/material'
import SearchIcon from '@mui/icons-material/Search'
import './ModalFilterSearch.css'

const ModalFilterSearch = ({ onModelChange, name, placeholder }) => {
  const [state, setState] = useState({ [name]: '' })

  const valueChange = event => {
    const { value } = event.target
    if (value === '') {
      onModelChange({ [name]: '' })
    }
    setState({ [name]: value })
  }

  const onKeyPress = event => {
    if (event.code === 'Enter') {
      onModelChange(state)
    }
  }

  return (
    <ContainerModalSetFilter>
      <TextField
        style={{ minWidth: '205px' }}
        className="SearchTextField"
        placeholder={placeholder}
        autoComplete="off"
        name={name}
        value={state[name]}
        onChange={valueChange}
        onKeyPress={onKeyPress}
        size="small"
        InputProps={{
          startAdornment: (
            <InputAdornment position="start">
              <SearchIcon className="SearchIcon" />
            </InputAdornment>
          )
        }}
      />
    </ContainerModalSetFilter>
  )
}

ModalFilterSearch.propTypes = {
  onModelChange: PropTypes.func,
  filters: PropTypes.object,
  name: PropTypes.string,
  placeholder: PropTypes.string
}

export default ModalFilterSearch
